import { render, staticRenderFns } from "./textCom.vue?vue&type=template&id=00d885db&"
import script from "./textCom.vue?vue&type=script&lang=js&"
export * from "./textCom.vue?vue&type=script&lang=js&"
import style0 from "./textCom.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports